module.exports = __webpack_public_path__ + "img/share.111840cf.png";